<template>
    <div class="footer t-c">
        <div class="p-4 container">
            <h3>Juandiego Calero</h3>
            <p>The place where my ideas come to die</p>
        </div>
    </div>
</template>

<script>
export default {
  name: "footer",
  props: {
    btn: String,
    url: String,
  }
};
</script>

<style lang="scss">
.footer {
    bottom: 0;
    left: 0;
    width: 100%;
    h3 {
        position: relative;
        &::before {
            border-top: 1px dotted #fff;
            content: '';
            display: block;
            margin-left: auto;
            margin-right: auto;
            left: 0;
            right: 0;
            position: absolute;
            top: -30px;
            width: 200px;
        }
    }
}
.btn-inicio {
    border-right: 0
}
</style>
